export default __webpack_public_path__ + "static/media/ordersIcon.3b2ba913.svg";